import { render, staticRenderFns } from "./NotificationAppointmentApproved.vue?vue&type=template&id=b71d45de&scoped=true&"
import script from "./NotificationAppointmentApproved.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentApproved.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71d45de",
  null
  
)

export default component.exports